import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './utils/firebaseClient';
import { LanguageProvider } from './contexts/LanguageContext';
import AuthPage from './pages/AuthPage';
import EventCreator from './components/event/EventCreator';
import EventDashboard from './components/event/EventDashboard';
import EvaluationPage from './pages/EvaluationPage';
import MyEvents from './components/event/MyEvents';
import HomePage from './pages/Homepage';
import Navbar from './components/navigation/Navbar';
import Footer from './components/navigation/Footer';
import CookieBanner from './components/CookieBanner';
import './styles/global.css';

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsub;
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <LanguageProvider>
    <BrowserRouter>
      <div className="app-container">
        <Navbar session={user} />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/my-events" element={user ? <MyEvents /> : <Navigate to="/login" />} />
          <Route path="/create" element={user ? <EventCreator /> : <Navigate to="/login" />} />
          <Route path="/event/:id" element={<EventDashboard />} />
          <Route path="/evaluate/:id" element={<EvaluationPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </div>
    </BrowserRouter>
    </LanguageProvider>
  );
};

export default App;
